import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const MaxTrailerWeight = ({ maxTrailerWeight }: SpecProps<"max_trailer_weight">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (maxTrailerWeight == null || maxTrailerWeight === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.max_trailer_weight",
    message: "Max trailer weight",
    comment: "Field for 'max trailer weight' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.common.weight.postfix",
    message: "{weight} kg",
    comment: "Weight incl. postfix",
    values: {
      weight: formatNumber(maxTrailerWeight, locale),
    },
  });
  return <FieldValuePair field={field} value={value} />;
};
